var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5249_4371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 10.8335C8.69138 11.3119 9.14796 11.7078 9.67229 11.9943C10.1966 12.2807 10.7764 12.4511 11.3724 12.4937C11.9683 12.5364 12.5665 12.4504 13.1263 12.2416C13.6861 12.0328 14.1944 11.706 14.6168 11.2835L17.1168 8.78347C17.8758 7.99763 18.2958 6.94512 18.2863 5.85263C18.2768 4.76014 17.8386 3.71509 17.0661 2.94256C16.2935 2.17002 15.2485 1.73182 14.156 1.72233C13.0635 1.71283 12.011 2.13281 11.2252 2.8918L9.79183 4.3168M11.6668 9.1668C11.309 8.68836 10.8524 8.29248 10.328 8.00602C9.80371 7.71955 9.22391 7.5492 8.62796 7.50652C8.032 7.46384 7.43384 7.54983 6.87405 7.75865C6.31425 7.96747 5.8059 8.29424 5.3835 8.7168L2.8835 11.2168C2.12451 12.0026 1.70453 13.0552 1.71402 14.1476C1.72352 15.2401 2.16172 16.2852 2.93426 17.0577C3.70679 17.8302 4.75184 18.2685 5.84433 18.2779C6.93681 18.2874 7.98932 17.8675 8.77517 17.1085L10.2002 15.6835",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5249_4371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.e6c847ac9b6404fcf7902874d9019694.svg";
export { ForwardRef as ReactComponent };